import { ResultProfilePage } from './../../../results/result-profile/result-profile';
import { ScanService } from './../../../../providers/scan.service';
import { Component, ComponentFactoryResolver, Input } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, Platform, ActionSheetController, ModalController, ToastController } from 'ionic-angular';
import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { ConfigProvider } from '../../../../providers/config/config';
import { EventProvider, MyEventListModel } from '../../../../providers/event/event';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { LanguageModel, SettingsProvider } from '../../../../providers/settings/settings';
import { SharingProvider } from '../../../../providers/sharing/sharing';
import { MyPicsListModel, MySportProfileListItem, PrivateProfile, PublicProfileModel, UserProvider } from '../../../../providers/user/user';
import { BackgroundModel, SinleValueModel, TextValueModel, ValueProvider } from '../../../../providers/value/value';
import { LoginPage } from '../../../login/login/login';
import { NotificationPage } from '../../../notification/main/notification';
import { TextContactPage } from '../../../textPages/text-contact/text-contact';
import { PrivateProfilePage } from '../../settings/private-profile/private-profile';
import { SettingsPage } from '../../settings/settings/settings';
import { MysportContactsPage } from '../mysport-contacts/mysport-contacts';
import { MysportEventsPage } from '../mysport-events/mysport-events';
import { MysportPhotosPage } from '../mysport-photos/mysport-photos';
import { MysportResultsPage } from '../mysport-results/mysport-results';
import { SessionProvider } from '../../../../providers/session/session';
import { NewsProvider, PagerModel } from '../../../../providers/news/news';
import { ResultSearchPage } from '../../../results/result-search/result-search';
import { NewsController, NewsRespond } from '../../../../providers/news/news-contoller';
import { EventSearchPage } from '../../../event/main/event-search/event-search';
import { TutorialProvider } from '../../../../providers/tutorial/tutorial';
import { IdRegistrationPage } from '../../../login/id-registration/id-registration';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { MysportRoutesPage } from '../mysport-routes/mysport-routes';
import { TeamSettingsModal } from '../../../team-settings-modal/team-settings-modal';
import { QRScanner } from '@ionic-native/qr-scanner';
import { MysportPurchasesPage } from '../mysport-purchases/mysport-purchases';
import { AdsProvider } from '../../../../providers/ads/ads';

@Component({
  selector: 'page-mysport-user-profile',
  templateUrl: 'mysport-user-profile.html'
})
export class MysportUserProfilePage {
  profile: PublicProfileModel;
  backgrounds: BackgroundModel[];

  facebookPage: string = '';
  instagramPage: string = '';
  twitterPage: string = '';
  youtubePage: string = '';
  flickrPage: string = '';
  xingPage: string = '';
  appName: string = "";

  hellahamburg: boolean = false;
  isPostbonnApp: boolean = false;
  isVivawestApp: boolean = false;
  isEmployeeDHL: boolean = false;
  isSpooortsApp: boolean = false;
  newsTab: boolean = false;
  showNews: boolean = false;
  isPremium:boolean=false;

  constructor(
    private platform: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    public userService: UserProvider,
    public loadingCtrl: LoaderProvider,
    public eventService: EventProvider,
    private iab: InAppBrowser,
    private valueService: ValueProvider,
    private categoryService: CategoriesProvider,
    private settingsService: SettingsProvider,
    private shareService: SharingProvider,
    private config: ConfigProvider,
    private sessionService: SessionProvider,
    private newsService: NewsProvider,
    private actionSheetCtrl: ActionSheetController,
    private tutorialProvider: TutorialProvider,
    private appDetector: AppDetectorProvider,
    private scanService: ScanService,
    private modalCtrl: ModalController,
    private actionCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private ads:AdsProvider
  ) {
    this.appVerification();
    this.profile = sessionService.profile as PublicProfileModel;

    if (!navParams.data.data) {
      this.getBackgrounds();
    } else {
      this.backgrounds = navParams.data.data.backgrounds;
    }

    this.platform.ready().then(async () => {
      this.facebookPage = (await this.config.config).social.facebook;
      this.instagramPage = (await this.config.config).social.instagram;
      this.twitterPage = (await this.config.config).social.twitter;
      this.youtubePage = (await this.config.config).social.youtube;
      this.flickrPage = (await this.config.config).social.flickr;
      this.xingPage = (await this.config.config).social.xing;
      this.appName = (await this.config.config).appId;
      this.newsTab = (await this.config.config).showHide.tabsNews;
      this.hellahamburg = this.appName.includes('hella');
    });
    if (this.platform.is('android')) {
      this.showPermissionMessage();
    }
  }

  getBackgrounds() {
    return new Promise<any>((resolve, reject) => {
      this.valueService.getProfileBackgrounds().then((backgrounds) => {
        resolve(backgrounds);
      });
    });
  }

  openGamePlan() {
    this.navCtrl.popToRoot();
    this.app.getRootNav().getActiveChildNav().select(1);
  }

  // getBackgrounds() {
  //   return new Promise<any>(async (resolve, reject) => {
  //     console.log('m-3.1.1');
  //     await this.valueService.getProfileBackgrounds().then(backgrounds => {
  //       this.backgrounds = backgrounds;
  //       console.log('m-3.1.2');

  //       resolve(null);
  //     });
  //   })
  // }

  async appVerification() {
    let name: string = (await this.config.config).appId;

    this.isPostbonnApp = name.toLocaleLowerCase().includes("postbonn");
    this.isVivawestApp = name.toLocaleLowerCase().includes("vivawest");
    this.isSpooortsApp = name.toLocaleLowerCase().includes("com.spooorts.eventsoriginal");
    console.log('m-1.1');

  }

  isOrganizer() {
    if (this.sessionService.profile) {
      return this.sessionService.profile.status.toLocaleUpperCase().includes("VERANST") || this.sessionService.profile.status.toLocaleUpperCase().includes("ORGAN");
    } else {
      return false;
    }
  }

  readonly SCANNER_SEC_KEY = "spooortsregistrationsecretkey";
  scanQR() {
    this.scanService.startScanner().then((info) => {
      let data = info.split('_');
      console.log('info: ' + info);
      let key = data[0];
      let eventId = data[1];
      let lid = data[2];
      if (this.SCANNER_SEC_KEY != key) return;
      this.sessionService.getToken().then(token => {
        this.eventService.getPrivateProfileByLid(lid, eventId, token).then((profile) => {
          Promise.all([
            this.valueService.getProfileTitles(),
            this.valueService.getProfileTypes(),
            this.valueService.getCountries(),
            this.categoryService.getProfileCategoires(),
            this.valueService.getProfileBackgrounds()
          ]).then(values => {
            (this.app.getRootNav() as NavController)
              .push(PrivateProfilePage, {
                data: {
                  titles: values[0],
                  types: values[1],
                  countries: values[2],
                  categories: values[3],
                  photos: [],
                  backgrounds: values[4],
                  profile: profile,
                  readOnly: true
                }
              });
          });
        });
      });
      // this.valueService.getProfileBackgrounds().then(backgrounds => {


      //   this.userService.getPublicProfile(profileId).then((value: PublicProfileModel) => {
      //     (this.app.getRootNav() as NavController)
      //       .push(ResultProfilePage, { data: { profile: null, backgrounds: backgrounds, result: [] } })
      //     loader.dismiss();
      //   });
      // });
    });
  }
  openPurchases() {
    this.navCtrl.push(MysportPurchasesPage);
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad MysportUserProfilePage');
    if (this.isLoged)
      this.checkNews();
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  checkNews() {
    if (this.appDetector.isForestApp()) return;

    let loader = this.loadingCtrl.create({
      content: ""
    });
    loader.present();

    if (!this.newsTab) { loader.dismiss(); return; }

    NewsController.getInstance().getNews(true).then((respond) => {
      this.tutorialProvider.isFirstRun().then(status => {
        if (!status) {
          if (respond.update) {
            if (respond.type.toLocaleUpperCase().includes("DHL")) {
              this.userService.checkLoged().then(logged => {
                if (logged) {
                  if (this.sessionService.profile.clubName.includes("DHL"))
                    this.presentNewsActionSheet(respond);
                }
                else
                  return;
              });
            } else {
              this.presentNewsActionSheet(respond);
            }
          }
        } else {
          this.tutorialProvider.setTutorialDone();
        }
        loader.dismiss();
      })
    });
  }

  openNews() {
    this.navCtrl.push(NotificationPage);
  }

  openTournine() {
    this.navCtrl.popToRoot();
    this.app.getRootNav().getActiveChildNav().select(0);
  }

  presentNewsActionSheet(respond: NewsRespond) {
    if (respond.type.includes("DHL") && !this.appName.includes("postbonn")) {
      return;
    }

    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('NEW_NEWS'),
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            if (respond.type.includes("DHL")) {
              if (this.sessionService.profile.clubName.includes("Deutsche Post DHL Group") && this.appName.includes("postbonn")) {
                (this.app.getRootNav() as NavController).push(NotificationPage, { news: respond.data, dhl: true });
              }
            }
            else {
              (this.app.getRootNav() as NavController).pop();
              this.app.getRootNav().getActiveChildNav().select(1);
            }
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }


  ionViewWillLeave() {
    NewsController.getInstance().isAllowed = true;
  }

  getNewsNumber() {
    if (this.appDetector.isForestApp()) return;

    return NewsController.getInstance().unreadNewsNumber.newsDHL;
  }

  onNewsTab() {
    this.navCtrl.push(NotificationPage, { news: NewsController.getInstance().news.newsDHL, dhl: true });
  }

  //the function is only for Postbonn Client
  onResultsTab() {
    this.navCtrl.push(ResultSearchPage, { userSection: true });
  }

  onViewWillEnter() {
    this.profile = this.sessionService.profile as PublicProfileModel;
  }

  public get isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  getPermissionDHL() {
    if (this.sessionService.profile) {
      return this.sessionService.profile.clubName.includes("Deutsche Post DHL Group") ? true : false;
    } else {
      return false;
    }
  }

  openEventsPage() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    if(this.appDetector.isSpooortsApp()){
      this.eventService.getMyEvents().then((value: MyEventListModel[]) => {
        this.navCtrl.push(MysportEventsPage, { data: value }).then(() => loader.dismiss());
      });
    }
    else{
    this.eventService.getMyEvents().then((value: MyEventListModel[]) => {
      this.navCtrl.push(MysportEventsPage, { data: value }).then(() => loader.dismiss());
    })
  }

  }

  openContacts() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.getMyFriends().then((friendList: MySportProfileListItem[]) => {
      this.navCtrl.push(MysportContactsPage, { friendList: friendList }).then(() => loader.dismiss());
    });
  }
  openPhotos() {
      var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      loader.present();
      this.userService.getMyPhotos().then(pictures => {
        this.navCtrl.push(MysportPhotosPage, { pictures: pictures, type: "photos" }).then(() => loader.dismiss());
      });
    // }
  }


  openRoutes() {
    this.navCtrl.push(MysportRoutesPage);
  }

  openBibPhotos() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.getMyBibPhotos().then(pictures => {
      console.log(pictures);
      this.navCtrl.push(MysportPhotosPage, { pictures: pictures, readOnly: true, type: "bibs" }).then(() => loader.dismiss());
    });
  }
  openShirtsPhotos() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.getMyShirtsPhotos().then(pictures => {
      console.log(pictures);
      this.navCtrl.push(MysportPhotosPage, { pictures: pictures, readOnly: true, shirts: true, type: "shirts" }).then(() => loader.dismiss());
    });
  }

  openTeamSettings() {
    const modal = this.modalCtrl.create(TeamSettingsModal);
    modal.onDidDismiss(option => {
      console.log('option',option)
    })
    modal.present();
  }

  openResults() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.getMyResults().then(results => {
      this.navCtrl.push(MysportResultsPage, { results: results }).then(() => loader.dismiss());
    });
  }

  openEventbaxx() {
    let browser = this.iab.create("https://hamburghalbmarathon.fanomena.events/");
    browser.show();
  }

  openNotification() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.newsService.getMyNews({
      limit: 25 + '',
      page: 1 + '',
      start: 0 + ''
    }).then(results => {
      console.log("news results", results);
      this.navCtrl.push(NotificationPage, { news: results || [] }).then(() => loader.dismiss());
    })

  }

  getProfileBg() {
    // let themeImage = (this.appName.includes("postbonn")) ? 'yellow_curt_bg.jpg' : 'blue_curt_bg.jpg';
    let themeImage = 'wood.jpg';

    if (!this.profile || this.profile.themeName.length == 0) return themeImage;
    if (this.profile) {

      if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
        // Bug in Gesunder app 
        if (this.profile.themeName.includes("www.")) return themeImage;

        if (typeof this.backgrounds === "undefined") {
          this.getBackgrounds().then((backgrounds) => {
            this.backgrounds = Object.assign([], backgrounds);
            themeImage = backgrounds.find(x => x.value === this.profile.themeName).img;
          });
        } else {
          if(this.profile.themeName ==='spooorts.de') this.profile.themeName = 'blue-curtain';
          themeImage = this.backgrounds.find(x => x.value === this.profile.themeName).img;
        }
      }
    }

    return themeImage;
  }

  getHeaderShade() {
    let themeShade = 'dark';
    if (!this.profile || this.profile.themeName.length == 0) return themeShade;

    if (this.profile) {
      if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
        if (typeof this.backgrounds === "undefined") {
          // Bug in Gesunder app 
          if (this.profile.themeName.includes("www.")) return themeShade;

          this.getBackgrounds().then((backgrounds) => {
            this.backgrounds = Object.assign([], backgrounds);
            themeShade = backgrounds.find(x => x.value === this.profile.themeName).shade;
          });
        }
      } else {
        if (typeof this.backgrounds === "undefined") {
          this.getBackgrounds().then((backgrounds) => {
            this.backgrounds = Object.assign([], backgrounds);
            themeShade = backgrounds.find(x => x.value === this.profile.themeName).shade;
          });
        } else {
          let index = this.backgrounds.find(x => x.value === this.profile.themeName).shade;
        }
      }
    }

    return themeShade;
  }

  showContactPage() {
    this.navCtrl.push(TextContactPage);
  }

  openSettings() {
    //this.settingsService.
    Promise.all([this.settingsService.getLanguages(), this.settingsService.getActiveLanguage()]).then(datas => {
      this.navCtrl.push(SettingsPage, {
        data: {
          languages: datas[0],
          selectedLanguage: datas[1]
        }
      });
    });
  }

  openProfile() {
    if (this.sessionService.isLoged) {
      let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      loader.present();
      Promise.all([
        this.valueService.getProfileTitles(),
        this.valueService.getProfileTypes(),
        this.valueService.getCountries(),
        this.categoryService.getProfileCategoires(),
        this.userService.getMyPhotos(),
        this.valueService.getProfileBackgrounds(),
        this.userService.getPrivateProfile()
      ]).then(values => {
        this.navCtrl
          .push(PrivateProfilePage, {
            data: {
              titles: values[0],
              types: values[1],
              countries: values[2],
              categories: values[3],
              photos: values[4],
              backgrounds: values[5],
              profile: values[6]
            }
          })
          .then(() => loader.dismiss());
      });
    } else {
      if (this.appDetector.isHellaApp()) {
        this.sessionService.getToken(false, false).then(token => {
          this.app.getRootNav().push(IdRegistrationPage);
        });
      } else {
        new Promise<any>((resolve, reject) => {
          (this.app.getRootNav() as NavController).push(LoginPage, { resolve: resolve });
        }).then(() => {
          if (this.appDetector.isGesunderApp() || this.appDetector.isForestApp()) {
            this.sessionService.getToken(false, true).then(token => {
              this.app.getRootNav().getActiveChildNav().select(3);
            });
          }
        });
      }
    }
  }

  openActivities() {
    this.app.getRootNav().getActiveChildNav().select(3);
  }

  openFacebook() {
    let browser = this.iab.create(this.facebookPage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  openInstagram() {
    let browser = this.iab.create(this.instagramPage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  openTwitter() {
    let browser = this.iab.create(this.twitterPage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  openYoutube() {
    let browser = this.iab.create(this.youtubePage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  openFlickr() {
    let browser = this.iab.create(this.flickrPage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  openXing() {
    let browser = this.iab.create(this.xingPage, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  share() {
    this.shareService.share('/ui/showTrophyPublicMe.jsf?mo=pub&id=' + this.sessionService.profile.id + '&current=' + new Date().getTime());
  }

  onLogout() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.logout().then(succ => {
      if (succ) {
        (this.app.getRootNav() as NavController).popToRoot();
        localStorage.setItem('premium', JSON.stringify(false));
      }
      loader.dismiss();
    });
  }
  showPermissionMessage() {
    this.tutorialProvider.isFirstRun(this.tutorialProvider.IMAGE_PERMISSION_MESSAGE_KEY).then((status) => {
      if (status) {
        let app = "";
          this.presentPermission(this.translate.instant("IMAGE_PERMISSION_MESSAGE", { name: app }), "permission-sheet");
  
      }
    });
  }
  presentPermission(message, cssclass) {
    let msg = this.actionCtrl.create({
      title: message,
      buttons: [
        {
          text: this.translate.instant('ALLOW_UPLOAD_PHOTO'),
          // text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
          role: this.translate.instant('ALLOW_UPLOAD_PHOTO'),
          handler: () => {
            this.userService.enableImageUpload(); 
            this.tutorialProvider.setTutorialDone(this.tutorialProvider.IMAGE_PERMISSION_MESSAGE_KEY);
          }
        },
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
          role: this.translate.instant('DENY_UPLOAD_PHOTO'),
          handler: () => {
            this.userService.disableImageUpload();
            this.tutorialProvider.setTutorialDone(this.tutorialProvider.IMAGE_PERMISSION_MESSAGE_KEY);
          }
        }
      ],
      cssClass: cssclass,
    });
    msg.present();
  }
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-user-profile/mysport-user-profile.ts